import { useEffect, useState } from 'react';
import { useStoreConfig } from '../context/StoreConfigContext.jsx';
import { bodyUrl } from '../lib/minecraft.js';
import '../styles/components/CustomerGoalStyle.css';

const wholeEuros = (amount) => `€${Math.round(amount).toLocaleString('en-US')}`;

export function CustomerGoal() {
  const { goal, topCustomer } = useStoreConfig();

  if (!goal) return null;

  return (
    <div className="customer-goal-row">
      <div className="top-customer">
        <h3 className="top-title">
          <i className="fa-solid fa-crown" /> Top Customer
        </h3>
        <div className="top-player">
          {}
          <img
            src={bodyUrl(topCustomer?.username, 96)}
            className="top-skin"
            alt={topCustomer?.username ?? 'Steve'}
            loading="lazy"
            decoding="async"
          />
          <div className="top-info">
            {topCustomer ? (
              <>
                <strong>{topCustomer.username}</strong>
                <span>
                  {topCustomer.orders} order{topCustomer.orders > 1 ? 's' : ''}
                </span>
              </>
            ) : (
              <>
                <strong>—</strong>
                <span>No orders yet</span>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="community-goal">
        <h3 className="goal-title">
          <i className="fa-solid fa-bullseye" /> Community Goal
        </h3>
        <div className="goal-percent">
          <span className="goal-pct-num">{goal.percent}%</span> completed
        </div>
        <GoalBar percent={goal.percent} />
        <div className="goal-amounts">
          <span>
            <strong>{wholeEuros(goal.revenue)}</strong> raised
          </span>
          <span>
            <strong>{wholeEuros(goal.target)}</strong> goal
          </span>
        </div>
        <p className="goal-note">{goal.note}</p>
      </div>
    </div>
  );
}


function GoalBar({ percent }) {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => setWidth(percent), 150);

    return () => clearTimeout(timer);
  }, [percent]);

  return (
    <div className="goal-bar">
      <div className="goal-progress" style={{ width: `${width}%` }} />
    </div>
  );
}
